<section
  *ngIf="!isImage() && !isVideo()"
  [class]="envia ? 'own chatFile-container' : 'other chatFile-container'"
>
  <img class="chatFile-icon" [src]="whichFile()">
  <div class="download-button">
    <button mat-button mat-stroked-button class="button-chat" (click)="download()">
      Descargar
    </button>
  </div>
</section>
<span class="chat-text">
@if (!isImage()) {
  {{ file.fileName }}
} @else {
  <img class="chat-img" [src]="file.url" (click)="openImages()" [alt]="file.fileName">
}
</span>
<video *ngIf="isVideo()" controls>
  <source [src]="file.url">
</video>
